import {Alert, IconButton, Stack, Typography} from "@mui/material";
import {Subscription} from "../../types/Subscription";
import {Delete} from "../common/Delete"
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {DefaultError} from "@tanstack/query-core";
import {enqueueSnackbar} from "notistack";
import {deleteSubscription} from "../../service/subscription.service";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import {useAuthStore} from "../../store/auth.store";
import {Link} from "react-router-dom";

interface ProposalSubscriptionComponentProps {
    subscriptions: Subscription[];
    error?: Error|null;
    setSelectedSubscription: (subscription:Subscription) => void
    onClose: () => void
}

export function ProposalSubscriptionComponent({onClose, setSelectedSubscription, subscriptions, error}: ProposalSubscriptionComponentProps) {
    const queryClient = useQueryClient();
    const {user} = useAuthStore();
    const deleteMutation = useMutation<void, DefaultError, string>({
        mutationFn: (id) => deleteSubscription(id).then(() => void 0),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions', "my"] }).catch(e => {
                enqueueSnackbar({ message: "Failed to invalidate subscriptions query: " + e.message, variant: 'error' })
            });
        },
        onError: (error) => {
            enqueueSnackbar({ message: "Failed to delete subscription: " + error.message, variant: 'error' })
        }
    });


    return <div>
        {error && <Alert variant={"outlined"} color={"error"}>
            <>Failed to load subscriptions: {error && error.message ? error.message : JSON.stringify(error)}</>
        </Alert>}
        {user?.login && <Typography>{"Your email: " + user?.login}</Typography>}
        {!user?.login && <Typography>
            Your email is not set. Please check&nbsp;
            <Link to={"/profile?tab=profile"} onClick={onClose}>your profile</Link>
        </Typography>}

        {subscriptions && subscriptions.length === 0 ? <Stack className={"mb-15"}>
            <Typography>You are not subscribed</Typography>
        </Stack> : null}

        {subscriptions && subscriptions.length > 0 && <div className={"mb-15"}>
            {subscriptions.map(s => <Stack
                justifyContent={"space-between"}
                alignItems={"center"}
                key={s.id}
                flexDirection={"row"}
            >
                <span>Daily subscription</span>
                <Stack flexDirection={"row"} alignItems={"center"} >
                    <IconButton onClick={() => {
                        setSelectedSubscription(s)
                    }}>
                        <EditNoteOutlinedIcon/>
                    </IconButton>
                    <Delete onConfirm={() => deleteMutation.mutate(s.id)} />
                </Stack>
            </Stack>)}
        </div>}
    </div>
}